import script from "./QTLiteSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteSkeleton.vue?vue&type=style&index=0&id=4dfa03cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfa03cc"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
